import IEnquiry from "../../models/contact/IEnquiry";

export interface IContactFormValidation {
    name: boolean;
    phone: boolean;
    email: boolean;
    emailInvalid: boolean;
    message: boolean;
}

export const NewContactFormValidation = (): IContactFormValidation => ({
    name: false,
    phone: false,
    email: false,
    emailInvalid: false,
    message: false
});

export function validate(enquiry: IEnquiry, setValidation: (validation: IContactFormValidation) => void): boolean {
    const validation = NewContactFormValidation();

    if (!enquiry.name.trim()) {
        validation.name = true;
    }

    if (!enquiry.phone.trim()) {
        validation.phone = true;
    }

    if (!enquiry.email.trim()) {
        validation.email = true;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(enquiry.email)) {
        validation.emailInvalid = true;
    }
    
    if (!enquiry.message.trim()) {
        validation.message = true;
    }

    setValidation(validation);
    return Object.values(validation).every(value => value === false);
}